module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/079-st-barts-ab2a5c824cc11104d7b7d354f85205ec.svg";